export const RegistrationSelector = (state) => state.registration;